import styled  from 'styled-components'

export const MenuIcon = styled.i`
margin-right: 20px;
cursor: pointer;
  @media (min-width: 1240px) {
    display: none;
  }
`